/* Copyright (c) Trimble Inc. All rights reserved. */

import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { memo } from 'react';


export const MemberRequestIcon: React.FC<SvgIconProps> = memo((props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M9 10.9999C9 10.4499 8.55 9.99986 8 9.99986H6V7.99986C6 7.44986 5.55 6.99986 5 6.99986C4.45 6.99986 4 7.44986 4 7.99986V9.99986H2C1.45 9.99986 1 10.4499 1 10.9999C1 11.5499 1.45 11.9999 2 11.9999H4V13.9999C4 14.5499 4.45 14.9999 5 14.9999C5.55 14.9999 6 14.5499 6 13.9999V11.9999H8C8.55 11.9999 9 11.5499 9 10.9999ZM14.5 11.9399C16.73 11.9399 18.54 10.1299 18.54 7.89986C18.54 5.66986 16.73 3.85986 14.5 3.85986C12.27 3.85986 10.46 5.66986 10.46 7.89986C10.46 10.1299 12.27 11.9399 14.5 11.9399ZM21.31 14.6899C20 14.0899 17.59 13.2099 14.49 13.2199C11.41 13.2199 8.98 14.0899 7.67 14.6899C6.36 15.2899 5.99 15.7699 5.99 16.6199C5.99 17.0799 6.24 18.0099 6.46 18.7999C6.67 19.5199 7.34 20.0199 8.09 20.0199H20.89C21.65 20.0199 22.31 19.5199 22.52 18.7999C22.75 18.0299 22.99 17.0799 22.99 16.6199C22.99 15.7699 22.62 15.2899 21.31 14.6899Z" fill="inherit"/>
    </SvgIcon>
  );
});

export default MemberRequestIcon;
